module.exports = __webpack_public_path__ + "media/images/gray_lock_icon_NC-96fe645e.png";